export default __webpack_public_path__ + "static/media/item.d19cb34c.svg";